import React from "react";
import { Link } from "react-router-dom";
import HR from "../../Components/HR";
import img from "../../Media/hero-illustration.webp";
import pp from "../../Media/paul-profile.webp";

const Hero = () => {
  return (
    <section class="bg-white dark:bg-gray-900" id="Projects">
      <div class="grid py-8 lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
        <div class="md:hidden lg:mt-0 lg:col-span-6 mb-10">
          <img src={img} alt="mockup" />
        </div>
        <div class="mr-auto place-self-center lg:col-span-6">
          <h1 class="max-w-2xl mb-4 tracking-tight leading-none text-3xl md:text-[45px] font-bold text-secondaryBold">
            We Automate Business process{" "}
            <span className="text-black">using Intelligent</span> Bots!
          </h1>
          <div className="border-l-8 pl-5 border-secondaryBG mt-8">
            <p className="text-xl font-semibold text-[#6B7280]">
              Earlier this month my team implemented their first bot.Concept to
              implementation was less than 60 days and ROI will exceed 600%!
              Most importantly, it eliminates repetitive daily tasks to drive
              better customer and employee experience. A huge thank you to{" "}
              <span className="text-secondarySmall">Pramod Rai</span> and the
              fantastic team at{" "}
              <span className="text-secondarySmall">Qualyval !</span>
            </p>
            <div className="flex items-center mt-4">
              <img className="mr-3" src={pp} alt="" />
              <div>
                <h4 className="text-lg font-bold">Paul Croke</h4>
                <p>President at Hinrichs Estimating</p>
              </div>
            </div>
          </div>
        </div>
        <div class="hidden md:flex lg:mt-0 lg:col-span-6 ">
          <img src={img} alt="mockup" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
